<footer class="footer ">
    <div class="container-fluid">
        <div class="row">
            <div class="col-sm-6">
                {{year}} © GrowthERP(Version 2.0).
            </div>
            <div class="col-sm-6">
                <div class="text-sm-end d-none d-sm-block" href="http://growthlooptechnologies.com/">
                    Design & Developed by <a href="http://growthlooptechnologies.com/"
                        class="text-decoration-underline">GrowthLoop
                        Technologies</a>
                </div>
            </div>
        </div>
    </div>
</footer>